<script lang="ts" setup>
const props = defineProps<{
  label: string;
  type?: string;
  modelValue: string;
  required?: boolean;
  placeholder?: string;
  min?: string;
  max?: string;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

const inputType = props.type || 'text';
</script>

<template>
  <div class="mb-4">
    <label class="block font-medium text-brand-dark mb-2">
      {{ label }}
      <span v-if="required" class="text-dark">*</span>
    </label>
    <input
      :type="inputType"
      :value="modelValue"
      :placeholder="placeholder"
      :required="required"
      :min="min"
      :max="max"
      class="w-full px-4 py-3 border bg-white/66 border-secondary rounded-lg focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent"
      @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    >
  </div>
</template>
